import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import './Pagination.css'
import SVG from 'react-inlinesvg';
import rightArrow from '../../assets/chevron-right-solid.svg';
import leftArrow from '../../assets/chevron-left-solid.svg';

function isNumber(val) {
    return /^[-]?\d+$/.test(val);
}

class Pagination extends Component {

    constructor(props) {
        super(props);
        this.state = {
            pageLimit: isNumber(props.pageLimit) ? parseInt(props.pageLimit, 0) : 30,
            totalRecord: isNumber(props.totalRecords) ? parseInt(props.totalRecords, 0) : 0,
            currentPage: isNumber(props.currentPage) ? parseInt(props.currentPage, 0) : 0,
            totalPages: isNumber(props.totalPages) ? parseInt(props.totalPages, 0) : 0,
            previousPage: parseInt(this.props.currentPage, 0) - 1,
            nextPage: parseInt(this.props.currentPage, 0) + 1,
            loading: false,
            column: typeof this.props.column !== 'undefined' ? this.props.column : false,
            direction: typeof this.props.direction !== 'undefined' ? this.props.direction : false,
            paginationInputValue: isNumber(props.currentPage) ? parseInt(props.currentPage, 0) : 0
        };

        this.handleClick = this.handleClick.bind(this);
        this.getParmas = this.getParmas.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidUpdate(prevProps) {
        if ((prevProps.totalPages !== this.props.totalPages || prevProps.currentPage !== this.props.currentPage) || prevProps.loading !== this.props.loading) {
            let props = this.props;
            this.setState({
                pageLimit: isNumber(props.pageLimit) ? parseInt(props.pageLimit, 0) : 30,
                totalRecord: isNumber(props.totalRecords) ? parseInt(props.totalRecords, 0) : 0,
                currentPage: isNumber(props.currentPage) ? parseInt(props.currentPage, 0) : 0,
                totalPages: isNumber(props.totalPages) ? parseInt(props.totalPages, 0) : 0,
                previousPage: parseInt(this.props.currentPage, 0) - 1,
                nextPage: parseInt(this.props.currentPage, 0) + 1,
                loading: this.props.loading,
                column: typeof this.props.column === 'undefined' ? false : this.props.column,
                direction: typeof this.props.direction === 'undefined' ? false : this.props.direction,
                paginationInputValue:  isNumber(props.currentPage) ? parseInt(props.currentPage, 0) : 0
            });
        }
    }
    handleChange(event) {
        let value = parseInt(event.target.value);
        let min = 1;
        let max = this.state.totalPages;
        if(event.target.value === "" || !isNaN(value)){
            if(event.target.value === "" || value >= min && value <= max){
                this.setState({paginationInputValue: event.target.value.replace(/\D/,'')})
            }
        }
    }


    handleClick = page => e => {
        if (page <= 0 || page > this.state.totalPages) {
            e.preventDefault();
        }
    };

    getParmas(next) {
        let page = next ? this.state.nextPage : this.state.previousPage;
        let urlQuery = '';
        if (typeof this.props.filter !== 'undefined') {
            urlQuery += this.props.filter + "&";
        }
        urlQuery += 'page=' + page;
        if (this.state.column !== false && this.state.direction !== false && this.props.column !== "" && this.props.direction !== "") {
            urlQuery += "&sort_col=" + this.props.column + "&sort_dir=" + this.props.direction;
        }
        return urlQuery;
    }
    handleKeyDown = (e) => {
        if (e.keyCode === 13 || e.keyCode === 9) {
            let url = "";
            if(this.props.route === '/search'){
                if (typeof this.props.filter !== 'undefined') {
                    url += this.props.route + "?" + this.props.filter + "&";
                }
                url += 'page=' + this.state.paginationInputValue;
            }
            if(this.props.route === '/latest-units'){
                url = this.props.route + "?page=" + this.state.paginationInputValue
            }
            if (this.state.column !== false && this.state.direction !== false && this.props.column !== "" && this.props.direction !== "") {
                url += "&sort_col=" + this.props.column + "&sort_dir=" + this.props.direction;
            }
            this.props.history.push(url);
        }
    }

    render() {
        const {loading, currentPage, nextPage, previousPage, totalPages} = this.state;
        if (totalPages === 1) return null;
        return (
            <React.Fragment>
                <ul className="pagination">
                    <li>
                        <span className="pagination-details">Page <input
                            className="pagination-input"
                            type="text"
                            pattern="[0-9]*"
                            min={1}
                            max={totalPages}
                            value={this.state.paginationInputValue}
                            onKeyDown={this.handleKeyDown}
                            onChange={this.handleChange}/> of {totalPages}</span>
                    </li>
                    <li>
                        <div className={`page-item page-item--control page-item--control-prev ${previousPage === 0 || loading ? 'page-item--control--disabled' : ''}`}>
                            <Link to={{pathname: this.props.route, search: this.getParmas(false)}} className="page-link"
                                  aria-label="Previous" onClick={this.handleClick(previousPage)}>
                                <SVG src={leftArrow}  />
                            </Link>
                        </div>
                        <div className={`page-item page-item--control ${loading || nextPage > this.props.totalPages ? 'page-item--control--disabled' : ''}`}>
                            <Link to={{pathname: this.props.route, search: this.getParmas(true)}} className="page-link"
                                  aria-label="Next" onClick={this.handleClick(nextPage)}>
                                <SVG src={rightArrow}  />
                            </Link>
                        </div>
                    </li>
                </ul>
            </React.Fragment>
        );
    }
}


export default Pagination;